var niacsProjectApp = angular.module('NiacsProjectApp',[
    'ngRoute',
    'ngAnimate',
    'templates-niacs',
    'NiacsProjectApp.filters',
    'NiacsProjectApp.services',
    'NiacsProjectApp.directives',
    'NiacsProjectApp.controllers',
    'ui.bootstrap',
    'ui.bootstrap.alert',
    //'monospaced.elastic',
    'ngSlider'
])
.config(['$routeProvider',function($routeProvider) {
    $routeProvider.when('/homework/:id/:hwId',{templateUrl:'partials/homework.html'});
    // one view per menu item
    angular.forEach(niacs.flattenMenu(),function(item){
      if(item.item) {
        $routeProvider.when('/'+item.item+'/:id',{templateUrl:'partials/'+item.item+'.html'});
      }
    });
}])
.directive('rootProject',[function(){
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'partials/directives/root-project.html'
  };
}]);

var niacsCourseMaterialsApp = angular.module('NiacsCourseMaterialsApp',[
  'ngRoute',
  'templates-niacs',
  'NiacsProjectApp.services',
  'NiacsProjectApp.directives',
  'ui.bootstrap'  
]).config(['$routeProvider',function($routeProvider){
  $routeProvider.when('/:courseId/:offeringId',{templateUrl:'partials/lms/course-materials.html'});
}]);

var niacsStrategiesApp = angular.module('NiacsStrategiesApp',[
    'NiacsProjectApp.services',
    'templates-niacs',
    'ui.bootstrap'
])
.directive('rootStrategies',[function(){
  return {
    restrict: 'E',
    templateUrl: 'partials/directives/root-strategies.html'
  };
}])
.controller('StrategiesPdfCtrl',['$scope','$sce','$window','$timeout','NiacsStrategyService',
    function($scope,$sce,$window,$timeout,NiacsStrategyService){
        NiacsStrategyService.getSources().then(function(sources){
            var defaultSource = sources.reduce(function(dflt,s){
                    return dflt ? dflt : ('niacs_strategy_far2' === s.getSource() ? s : undefined);
                },undefined),
                alias = $window.location.pathname.substring($window.location.pathname.lastIndexOf('/')+1);
           $scope.strategySource = sources.reduce(function(resource,s){
                    if(alias === s.getSourceAlias()) {
                        return s;
                    }
                    return resource;
                },defaultSource);
            $scope.print = function() {
              $timeout(function(){
                $window.print();
              },500);
            };
            console.log('HERE!!!');
            $scope.strategySource.query(function(strategies){
                angular.forEach(strategies,function(s){
                  if(s.description) {
                    s.descriptionHtml = $sce.trustAsHtml(s.description);
                  }
                  angular.forEach(s.approaches,function(a){
                    if(a.description) {
                      a.descriptionHtml = $sce.trustAsHtml(a.description);
                    }
                    if(a.example) {
                        var isHeading = /:\s*$/,
                            exampleSets = [];
                        angular.forEach(a.example,function(example) {
                            if(isHeading.test(example)) {
                                exampleSets.push({
                                    heading: example,
                                    list: []
                                });
                            } else {
                                if(!exampleSets.length) {
                                    exampleSets.push({
                                        list: []
                                    });
                                }
                                exampleSets[exampleSets.length-1].list.push(example);
                            }
                        });
                        a.$exampleSets = exampleSets;
                    }
                  });
                });
                $scope.strategies = strategies;
            });
        });
}]);

var niacsDashboard = angular.module('NiacsProjectDashboardApp',[
    'ngRoute',
    'ngAnimate',
    'templates-niacs',
    'NiacsProjectApp.filters',
    'NiacsProjectApp.services',
    'NiacsProjectApp.directives',
    'NiacsProjectApp.controllers',
    'ui.bootstrap',
    'ui.bootstrap.alert',
    'monospaced.elastic'
])
.directive('rootDashboard',[function(){
  return {
    restrict: 'E',
    templateUrl: 'partials/directives/root-dashboard.html'
  };
}]);

var niacsExport = angular.module('NiacsProjectExportApp',[
    'ngRoute',
    'templates-niacs',
    'NiacsProjectApp.filters',
    'NiacsProjectApp.services',
    'NiacsProjectApp.directives',
    'NiacsProjectApp.controllers',
    'NiacsProjectApp.lms',
])
.config(['$routeProvider',function($routeProvider) {
    $routeProvider.when('/export/:id',{templateUrl:'partials/export.html'});
    $routeProvider.when('/lms-export/:course/:offering/:id',{templateUrl: 'partials/lms-export.html'});
    $routeProvider.otherwise({templateUrl:'partials/export.html'});
}]);

var niacsLmsDashboard = angular.module('NiacsLmsDashboardApp',[
  'ngRoute', // just for project export...
  'NiacsProjectApp.services',
  'NiacsProjectApp.lms',
]);

var niacsReview = angular.module('NiacsReviewApp',[
    'NiacsProjectApp.services',
    'NiacsProjectApp.review',
    'ui.bootstrap',
]);

var niacsReporting = angular.module('NiacsReportingApp',[
    'NiacsProjectApp.services',
    'NiacsProjectApp.reporting',
    'ui.bootstrap',
]);

var niacsBrowser = angular.module('NiacsBrowserApp',[
    'NiacsProjectApp.browser'
]);

var niacsApps = [niacsProjectApp,niacsDashboard,niacsStrategiesApp,niacsExport,niacsLmsDashboard,niacsReview,niacsReporting,niacsBrowser,niacsCourseMaterialsApp];

// don't complain about functions defined in loops here.
/* jshint loopfunc:true */
for(var i = 0; i < niacsApps.length;i++) {
  niacsApps[i].run(['$document','$http',function($document,$http){
    /*
     * The adaptation workbook UI was written to rely on the fact that Angular
     * would not serialize any properties beginning with '$'.  It uses them somewhat
     * extensively to store application state on objects it then sends to the server
     * to be persisted.  At some point Angular "fixed" this behavior and now only
     * avoids persisting properties prevised with '$$'.
     * see: https://github.com/angular/angular.js/issues/1463
     * The code in this run method puts back the old behavior for this application.
     * The content is pulled from the current (as of this moment) angular source
     * and comments out the requirement that both the 0 & 1 chars must be '$' before
     * being stripped out.
     */
    var document = $document[0] || {},
        toString = Object.prototype.toString;
    function isScope(obj) {
      return obj && obj.$evalAsync && obj.$watch;
    }
    function isFile(obj) {
      return toString.call(obj) === '[object File]';
    }
    function isFormData(obj) {
      return toString.call(obj) === '[object FormData]';
    }
    function isBlob(obj) {
      return toString.call(obj) === '[object Blob]';
    }
    function isWindow(obj) {
      return obj && obj.window === obj;
    }
    function toJsonReplacer(key,value) {
        var val = value;

        if (typeof key === 'string' && key.charAt(0) === '$'/* && key.charAt(1) === '$'*/) {
          val = undefined;
        } else if (isWindow(value)) {
          val = '$WINDOW';
        } else if (value &&  document === value) {
          val = '$DOCUMENT';
        } else if (isScope(value)) {
          val = '$SCOPE';
        }

        return val;
    }
    angular.toJson = function(obj,pretty) {
      if (typeof obj === 'undefined') { return undefined; }
      if (!angular.isNumber(pretty)) {
        pretty = pretty ? 2 : null;
      }
      return JSON.stringify(obj, toJsonReplacer, pretty);
    };
    $http.defaults.transformRequest = function(d) {
        return angular.isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? angular.toJson(d) : d;
    };
  }])
  .factory('niacsGlobalErrorInterceptor',['$q','$log','NotificationService',function($q,$log,NotificationService){
      return {
          'responseError' : function(err) {
              $log.error("ERROR",err);
              NotificationService.addError ("Error: " + err.status + " ["+err.statusText+"]");
              return $q.reject(err);
          }
      };
  }])
  .config(['$httpProvider','$uibTooltipProvider',function($httpProvider,$uibTooltipProvider){
      $httpProvider.interceptors.push('niacsGlobalErrorInterceptor');
      $httpProvider.defaults.headers.post['Content-Type'] = 'application/vnd.api+json';
      $httpProvider.defaults.headers.patch['Content-Type'] = 'application/vnd.api+json';
      // for future versions of REST resources
      //$httpProvider.defaults.headers.common['"X-Restful-Minor-Version"'] = 0;
      if(typeof(UAParser) !== 'undefined') {
          var parser = new UAParser(),
                  ua = parser.getResult(),
                  touch = ua.device && (ua.device.type === 'tablet' || ua.device.type === 'mobile');
          if(touch) {
              $uibTooltipProvider.options({
                  trigger: 'dontTrigger' // dummy trigger to avoid tooltips.
              });
          }
      }
  }]);
}
